if (!!document.getElementById("sublogo-submenu")) {
  const menuStructure = ["#second-level", "#third-level", "#fourth-level"];

  const openSubmenuButtons = document.querySelectorAll(".open-submenu");
  Array.from(openSubmenuButtons).forEach((button) => {
    button.addEventListener("click", function handleClick(event) {
      // Closes language selector and search bar when clicking on menu items.
      removeClass("submenu-language", "toggle");
      removeClass("language-selector", "toggle");
      addClass("menu-searchbar", "hidden");
      addClass("searchbar-toggle", "searchbar-open");

      let hide = false;
      menuStructure.forEach((x) => {
        const menu = document.querySelector(x);
        if (menu.querySelector("#child-" + button.id) !== null) {
          hide = true;
        }
        if (hide) {
          const visibleMenus = menu.querySelectorAll(".toggle");
          Array.from(visibleMenus).forEach((e) => {
            if (e.id !== "child-" + button.id) {
              toggleClass(e, "toggle");
              toggleClass(
                document.querySelector(e.id.replace("child-", "#")).parentNode,
                "open"
              );
            }
          });
        }
      });

      //Toggles classes.
      toggleClass(button.parentNode, "open");
      toggleClass(document.querySelector("#child-" + button.id), "toggle");
    });
  });

  // This closes all menus if language or search menu was opened.
  const menuOpenerButtons = document.querySelectorAll(".menu-opener");
  Array.from(menuOpenerButtons).forEach((button) => {
    button.addEventListener("click", function handleClick(event) {
      const clicked = button.id;
      if (clicked === "language-selector") {
        addClass("menu-searchbar", "hidden");
        addClass("searchbar-toggle", "searchbar-open");
      }
      if (clicked === "searchbar-toggle") {
        removeClass("submenu-language", "toggle");
        removeClass("language-selector", "toggle");
      }

      menuStructure.forEach((x) => {
        const menu = document.querySelector(x);
        const visibleMenus = menu.querySelectorAll(".toggle");
        Array.from(visibleMenus).forEach((e) => {
          if (e.id !== "child-" + button.id) {
            toggleClass(e, "toggle");
            toggleClass(
              document.querySelector(e.id.replace("child-", "#")).parentNode,
              "open"
            );
          }
        });
      });
    });
  });

  // Hides navbar when clicking outside element
  document.addEventListener("click", (event) => {
    const navbar = document.getElementById("navbar-sublogo");
    if (!navbar.contains(event.target)) {
      closeAll();
    }
  });
}

function closeAll() {
  const menuStructure = ["#second-level", "#third-level", "#fourth-level"];
  menuStructure.forEach((x) => {
    const menu = document.querySelector(x);
    const visibleMenus = menu.querySelectorAll(".toggle");
    Array.from(visibleMenus).forEach((e) => {
      toggleClass(e, "toggle");
      toggleClass(
        document.querySelector(e.id.replace("child-", "#")).parentNode,
        "open"
      );
    });
  });
  addClass("menu-searchbar", "hidden");
  addClass("searchbar-toggle", "searchbar-open");
  removeClass("submenu-language", "toggle");
  removeClass("language-selector", "toggle");
}

function removeClass(i, c) {
  if (
    !!document.getElementById(i) &&
    document.getElementById(i).classList.contains(c)
  ) {
    document.getElementById(i).classList.remove(c);
  }
}

function addClass(i, c) {
  if (
    !!document.getElementById(i) &&
    !document.getElementById(i).classList.contains(c)
  ) {
    document.getElementById(i).classList.add(c);
  }
}

function toggleClass(elem, c) {
  if (!!elem) {
    elem.classList.toggle(c);
  }
}
